import { Box, Button, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ReportHeader from '../../../common/ReportHeader'
import TextBox from '../../../common/TextBox'
import DeliveryDetails from './DeliveryDetails'
import ShipmentSnapShots from './ShipmentSnapShots'
import '../../../../style/ksrtc/CargoDelivery.scss'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import { SuccessfulMessage } from './DeliveryConstant'
import { cargoMenu } from '../../../../redux/Actions'
import { useDispatch, useSelector } from 'react-redux'
import { CargoDelivery, GetLuggageForDelivery } from '../../../../redux/KSRTC_Redux/bookingPage/bookingAction'
import { focusElemnt, navigation1, navigation3 } from '../../../../utilityFunctions'
import DemurrageReceiptPrint from './DemurrageReceiptPrint'
import Alert from '../../../common/Alert'

const Delivery = () => {
    const dispatch = useDispatch()
    const store = useSelector((store) => store);
	const { user = {} } = store;
    const [shipmentData, setShipmentData] = useState(false)
    const [consignment,setConsignment]=useState('')
    const [received,setReceived]=useState(false)
    const [openDemreceipt, setOpenDemReceipt] = useState(false)
    const [demPrintData, setDemPrintData] = useState([])
    const [showAlert, setShowAlert] = useState({
                msg: "",
                open: false,
            });
        const handleSetAlert = (msg) => {
            setShowAlert((prev) => ({
                ...prev,
                msg: msg,
                open: true,
            }));
        };
        const handleAlertClose = () => {
            setShowAlert((prev) => ({
                ...prev,
                msg: "",
                open: false,
            }));
        };
    const handleSearch = ()=>{
        if(!consignment){
            handleSetAlert("Please Enter Consignment Number");
            return
        }
        const body = {
            strLRNO:consignment,
            intCurrentCityID:user.CityID,
            intCurrentBranchID:user.BranchID,
            intUserID:user.UserID,
            intIsDelivered:0,
            intCurrentCounterID:user.CounterID,
            intCompanyID:user.CompanyID
        }
        dispatch(GetLuggageForDelivery(body)).then((response)=>{
            const {status,ErrMessage,Data} = response.data
            if(status==="Success"){
                const [data] = Data
                const {LRNO}= data
                setShipmentData(data)
            }else{
                setShipmentData(false)
                setOpenModal({
                    open: true,
                    msg: ErrMessage,
                    isError: true,
                    cancelReq: false
                })
                //handleError
            }
            
        })
    }
    const ErrorMsg = () => {
        return (
            <>
                {/* <Box sx={{fontWeight:"bold",marginBottom:"15px"}}>Consignment Error</Box>
                <Box>Selected Shipment Status is ready for </Box>
                <Box>Delivery. You can’t receive shipment</Box> */}
                <Box sx={{ fontWeight: "bold", marginBottom: "15px" }}>Short Fall Receiving Details</Box>
                <Box>Sorry ! You are receiving 1 out of 2 Items
                    for the selected shipment.
                    Do you want to continue Receiving </Box>
            </>
        )
    }
    const SuccessMsg = (props) => {
        const {units} = props
        return (
            <>
                {/* <Box sx={{fontWeight:"bold",marginBottom:"15px"}}>Consignment Error</Box>
                <Box>Selected Shipment Status is ready for </Box>
                <Box>Delivery. You can’t receive shipment</Box> */}
                <Box sx={{ fontWeight: "bold", marginBottom: "15px" }}>{units} {units===1?'Unit':'Units'} Successfully Delivered</Box>
                <Box>Consignment - <span style={{color: "#FF5200",fontWeight:"600"}}> {consignment} </span></Box>
            </>
        )
    }
    const handleDelivery = ()=>{
        // setOpenModal({
        //     open: true,
        //     msg: 'Consignment Already Delivered',
        //     isError: true
        // })
        if(shipmentData?.PendingDeliveyItems<=0){
            handleSetAlert(`Units to Deliver cannot be less than or equal to 0`);
            return
        }
        if(shipmentData?.PendingDeliveyItems>(shipmentData?.ReceivedItems-shipmentData?.DeliveredItems)){
            handleSetAlert(`Units to Deliver cannot be greater than  ${shipmentData?.ReceivedItems-shipmentData?.DeliveredItems}`);
            return
        }
        const data={
            intDeliveryID: 0,
            intCompanyID:  user.CompanyID,
            intBookingID: shipmentData.BookingID,
            strReceivedBy: shipmentData.ReceivedBy,
            strIDProof: "",
            strOctroiRcptNo: shipmentData.OctroiReceiptNo,
            dtOctroiRcptDate: shipmentData.OctroiReceiptDate,
            dblOctroiRcptAmt: shipmentData.OctroiReceiptAmt,
            strRemarks: shipmentData.Remarks||"",
            intUsreID: user.UserID,
            intPaymentType: shipmentData.PaymentType,
            strPaymentDetails: shipmentData.PaymentTypeDet,
            dblFreight: shipmentData.NetAmount,
            dblCollectionChg: shipmentData.CollectionCharges,
            dblCartage: shipmentData.CartageAmount,
            dblDocumentChg: shipmentData.DocumentCharges,
            dblInsurance: shipmentData.Insurance,
            dblServiceTax: shipmentData.DeliveryGST,
            dblTotal: shipmentData.NetAmount,
            dblTotalDues: shipmentData.NetAmount,
            dblHomeDeliveryChg: shipmentData.HomeDeliveryChg,
            dblOutstanding: 0,
            dblGoodsValue: shipmentData.GoodsValue,
            intReceivingPartyID: 0,
            dblAddtitionalDeliveryCartage: shipmentData.AdditionalDeliveryCartage,
            dblOctroiBrokerageAmt: shipmentData.OctroiBrokerageAmt,
            dblDemurrageChg: shipmentData.DemurrageChg,
            intIDProofid: 0,
            strreceiverimgurl: "",
            strIDProofimgurl: "",
            dblLatitude: 0,
            dblLongitude: 0,
            strDeliverdLocation: "",
            IsDeliverdLocation: 0,
            dblDeliveryGST: shipmentData.DeliveryGST,
            strReceiverContactNo: shipmentData?.RecMobileNo,
            dblExtraHamali: 0,
            strVehicleNo: "",
            strReceiverGSTN: shipmentData.ReceiverGSTN,
            strGSTPaidBy: "",
            dblDeliveryDisc: 0,
            WalletOrderId: 0,
            AccountNo: "",
            TransactionID: "",
            DeliveryItems:shipmentData.PendingDeliveyItems
          }
        dispatch(CargoDelivery(data)).then((response)=>{
            const {status,ErrMessage,Data} = response.data
            if(status==="Success"){
                if(Data!==null && Data?.Table?.length>0 && Data?.Table?.[0]?.IsDemurrage===1){
                    setDemPrintData(Data?.Table)
                }
                setReceived(true)
                setOpenModal({
                    open: true,
                    msg: <SuccessMsg units={shipmentData.PendingDeliveyItems}/>,
                    isError: false,
                    cancelReq: false
                })
            }else{
                setOpenModal({
                    open: true,
                    msg: ErrMessage,
                    isError: true,
                    cancelReq: true
                })
            }
        }).catch((error)=>{
            setOpenModal({
                open: true,
                msg: error,
                isError: true,
                cancelReq: true
            })
        })
    }
    //CargoDelivery
    const [openModal, setOpenModal] = useState({
        open: false,
        msg: '',
        isError: false
    })
    useEffect(() => {
        const timer = setTimeout(() => {
                focusElemnt("consignment-number");
        }, 200);       
        return () => clearTimeout(timer);
    }, []);
    return (
		<Box className="cargoDelivery" sx={{ paddingBottom: "60px" }}>
			<ReportHeader
				mainHeaderName="Cargo"
				headerName={"Delivery"}
				openSubMenu={() => {
					dispatch(cargoMenu(true));
				}}
				fixedTopPosition={true}
			/>
			<Box sx={{ padding: "16px", display: "flex", gap: "10px" }}>
				<Box sx={{ width: "300px" }}>
					<TextBox
						type={"number"}
						name={""}
                        id="consignment-number"
						label={"Consignment Number"}
						value={consignment}
                        onKeyDown={(e) =>
                            navigation1(e, "searchButton", "")
                        }
						onChange={({ target: { value = "" } }) =>
							setConsignment(value)
						}
					/>
				</Box>
				<Button
					variant="contained"
					size="medium"
					className={`btn-orange`}
					id="searchButton"
					onClick={() => handleSearch()}
                    onKeyDown={(e) => navigation1(e, "ReceivedBy9", "consignment-number")}
					sx={{ width: "100px" }}
				>
					SEARCH
				</Button>
			</Box>
            {shipmentData?
            <>
			<Divider />
			<DeliveryDetails
				shipmentData={shipmentData}
				setShipmentData={setShipmentData}
                handleSetAlert={handleSetAlert}
			/>
			<Box
				sx={{
					padding: "16px 16px 8px 16px",
					display: "flex",
					justifyContent: "end",
				}}
			>
				<Button
					variant="contained"
					size="medium"
					className={`btn-orange`}
					id="deliverybutton"
					onClick={() => handleDelivery()}
					sx={{ width: "100px" }}
                    onKeyDown={(e) =>
                        navigation3(
                            e,
                            "",
                            "Remarks13",
                            () => {}
                        )
                    }
				>
					DeliverY
				</Button>
			</Box>
            </>:""}
			{shipmentData ?<ShipmentSnapShots />:'' }
            {demPrintData ?<DemurrageReceiptPrint
				isPrint={openDemreceipt}
                setIsPrint={setOpenDemReceipt}
				demPrintData={demPrintData}
				closeTab={() => {
					setOpenDemReceipt(false);
				}}
			/>:''}
			<SuccessAndErrorModal
				open={openModal?.open}
				cancelRequired={false}
				backgroundColor={openModal?.isError ? "#FFF2E2" : "#E0EFD8"}
				dialogConfirmationMessage={
					<SuccessfulMessage
						isError={openModal?.isError}
						message={openModal?.msg}
					/>
				}
				onClose={() => {
                    if(received){
                        setShipmentData(false)
                        setReceived(false)
                    }
                    if(demPrintData?.length>0 && demPrintData?.[0].IsDemurrage===1){
                        setOpenDemReceipt(true)
                    }
					setOpenModal({
						open: false,
						msg: "",
						isError: false,
					});
				}}
			/>
            {showAlert?.open && (
				<Alert
					msg={showAlert?.msg}
					alertType={"error"}
					close={handleAlertClose}
					buttonText="OK"
				/> 
            )}
		</Box>
	);
}

export default Delivery